import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { Location } from 'history';
import { connect } from 'react-redux';
import { GlobalStateShared } from 'src/api';
import { IsAuthentificatedState } from 'loopback-react-request';

interface NoMatchRouteProps {
  authenticator: IsAuthentificatedState;
  location: Location;
  target?: string;
}

export class NoMatchRouteComponent extends React.Component<NoMatchRouteProps> {
  render() {
    const {
      authenticator,
      location,
      target,
    } = this.props;
    let fromTarget: string | undefined;

    const pageNotFoundUrl = !authenticator.isAuthentificated ? '/' : '/page-not-found';

    if (location.pathname !== pageNotFoundUrl) {
      fromTarget = location.pathname;
    }

    const to = `${(target || pageNotFoundUrl)}${fromTarget && '?from=' + fromTarget}`;
    
    const from = location.state || target;

    // console.log(authenticator);
    // console.log(target);
    // console.log(location);
    // console.log('YE', from);
    
    return (
      <Redirect
        to={from || to}
      />
    );
  }
}

export const NoMatchRoute = connect((state: GlobalStateShared) => ({
  authenticator: state.authenticator,
}))(NoMatchRouteComponent);